import type { Palette } from '@mui/material'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/berachain/lightPalette.json
 */
const TEMPLATE_PALETTE = {
  secondary: {
    dark: '#d99611',
    main: '#FDB72D',
    light: '#f8d08b',
    background: '#fff4ee',
  },
  logo: {
    main: '#2C1A16',
    background: '#303033',
  },
  background: {
    default: '#F4F4F4',
    main: '#F4F4F4',
    paper: '#FFFFFF',
    light: '#fff4ee',
    lightGrey: '#303033',
  },
} as Partial<Palette>
export default TEMPLATE_PALETTE
